import { FleekError } from './FleekError';

type FleekConfigInvalidContentErrorOptions = {
  configPath: string;
  validationResult?: string;
};

export class FleekConfigInvalidContentError extends FleekError<FleekConfigInvalidContentErrorOptions> {
  public name = 'FleekConfigInvalidContentError';

  toString = () => {
    if (this.data.validationResult) {
      return `Validation of loaded ${this.data.configPath} failed. ${this.data.validationResult}`;
    }

    return `Loaded ${this.data.configPath} file is corrupted.`;
  };
}
